import { render, staticRenderFns } from "./Gravity.vue?vue&type=template&id=0d81ca22&scoped=true&"
import script from "./Gravity.vue?vue&type=script&lang=js&"
export * from "./Gravity.vue?vue&type=script&lang=js&"
import style0 from "./Gravity.vue?vue&type=style&index=0&id=0d81ca22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d81ca22",
  null
  
)

export default component.exports